import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/billing/query/', 'bill');

tbl.add(new Xtc('id', 'Inv No').renderSlot('bill_id'))
tbl.add(new Xtc('to_contact.fullname', 'Client').renderSlot('contact'))
tbl.add(new Xtc('matters', 'Matter').renderSlot('matter'))
tbl.add(new Xtc('reference_code', 'Reference Code').renderSlot('reference_code'))
tbl.add(new Xtc('type', 'Type').renderSlot('type'))
tbl.add(new Xtc('issue_date', 'Invoice Date').renderSlot('issue_date'))
tbl.add(new Xtc('due_date', 'Payment Due').renderSlot('due_date'))
tbl.add(new Xtc('payed_amount', 'Amount Paid').renderSlot('payed_amount'))
tbl.add(new Xtc('outstanding_balance', 'Outstanding Balance').renderSlot('outstanding_balance'))
tbl.add(new Xtc('total_amount', 'Total Amount').renderSlot('total_amount'))
// tbl.add(new Xtc('client_amount_balance', 'Client Account Balance'))
tbl.add(new Xtc('detail_level', 'Detail level').hidden().renderSlot('level'))
tbl.add(new Xtc('status', 'Status').renderSlot('status'))
tbl.add(new Xtc('tax', 'Tax').renderSlot('tax').hidden())
//tbl.add(new Xtc('tax_second', 'Tax Second').hidden())
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))


export default tbl;

